import { EnumCommodity, EnumTipoSujeto } from '../../../../../api'
import { ContractModel } from '../../../../../api/Argentia/model/contracts'
import { ButtonOption } from '../../../../../components/shared/splitButton/splitButton'

export interface ContractsCardProps {
  isFetching: boolean
  isFetchingClient: boolean
  error: boolean
  contracts?: ContractModel[]
  commodities: EnumCommodity[] | undefined
  subjectType?: EnumTipoSujeto
  onClickAdd: (option: ButtonOption) => void
  onClickEdit: () => void
  onRetry: () => void
  onRefreshProcedureCard?: (string) => void
}

export namespace ContractAddButtonOptions {
  export const DEFAULT = 'default'
  export const STANDARD = 'standard'
  export const GAS = 'GasNatural'
  export const POWER = 'Electricidad'
  export const CHANGE_OWNER = 'newChangeOwner'
  export const COMMERCIAL = 'Commercial'
}
export type ContractAddButtonOptions =
  (typeof ContractAddButtonOptions)[keyof typeof ContractAddButtonOptions]
